<div *ngFor="let item of _items;let i = index" class="eachCard"
    [ngClass]="{'heroImage': item.featured, 'list-mode':  mode === 'list'}">
    <div *ngIf="item" (click)="addClicked(item)"
        [ngClass]="{'AQA-setItem': isSet[i], 'AQA-aLaCarteItem': !isSet[i],'not-showLogo': !isShowLogo && !getItemImage(item)}"
        class="item-wrapper animated fadeInUps item-card" ng-switch-when="category">

        <!-- no image mode element -->
        <ng-container *ngIf="!isShowLogo && !getItemImage(item)">
            <ion-icon _ngcontent-c6="" class="no-combo-add-icon no-logo-mode ios hydrated" name="md-add"
                ng-reflect-name="md-add" role="img" aria-label="add"></ion-icon>

            <div class="qty-panel no-logo-mode" *ngIf="orderManager.getQuantity(item) > 0 && !item?.variations">


                <!-- <div class="qty-panel" *ngIf="orderManager.getQuantity(item) > 0 && !item?.variations"> -->
            <!-- <ion-button fill="clear" class="btn-qty-remove AQA-minus-button"
                (click)="removeClicked(item);$event.stopPropagation();">
                <ion-icon name="md-remove"></ion-icon>
            </ion-button> -->
                <ion-icon (click)="removeClicked(item);$event.stopPropagation();" name="md-remove"
                    class="btn-qty-remove AQA-minus-button"></ion-icon>
        
                <div class="qtn-with-item">
                    <p class="AQA-item-qty">{{orderManager.getQuantity(item)}}</p>
                </div>
        
                <ion-icon name="md-add" class="btn-qty-add AQA-add-button"></ion-icon>
                <!-- <ion-button fill="clear" class="btn-qty-add AQA-add-button">
                    <ion-icon name="md-add"></ion-icon>
                </ion-button> -->

                    </div>
        
            <div class="sold-out-box AQA-soldOut no-logo-mode" *ngIf="isSoldout[i]">
                <span>{{"pages.item-grid.soldout" | translate}}</span>
            </div>
        
            <div *ngIf="item.tags.length > 0" class="tag-image-box no-logo-mode">
                <div class="tag-images-wrapper">
                    <ng-container *ngFor="let tagsImg of item.tags">
                        <img *ngIf="tagsImage[tagsImg]" src="{{tagsImage[tagsImg]}}"
                            [ngClass]="{'single' : item.tags.length == 1}">

                    </ng-container>
                </div>
            </div>
        </ng-container>



        <!-- no image mode element -->


        <div class="img-square center-cropped" style="background: white;">

           


            <div *ngIf="item.tags.length > 0" class="tag-image-box">
                <div class="tag-images-wrapper">
                    <ng-container *ngFor="let tagsImg of item.tags">
                        <img *ngIf="tagsImage[tagsImg]" src="{{tagsImage[tagsImg]}}"
                            [ngClass]="{'single' : item.tags.length == 1}">

                    </ng-container>
                </div>
            </div>
            <!-- Item tag -->
            <!-- <div *ngIf="item.tags.length > 0" class="tag-image-box"></div> -->
            <div class="item-img-box img-box" [ngStyle]="{'background-image': urls[i] }">
                <ion-icon name="md-add" class="combo-option" *ngIf="item.minPrice"></ion-icon>
                <ion-icon name="md-add" class="no-combo-add-icon" *ngIf="!item.minPrice"></ion-icon>
                <ng-container *ngIf="urls[i] == 'url(null)'">
                    <p class="no-img-text">{{item.name}}</p>
                </ng-container>
            </div>


            <div class="sold-out-box AQA-soldOut" *ngIf="isSoldout[i]">
                <span>{{"pages.item-grid.soldout" | translate}}</span>
            </div>
            <div class="qty-panel" *ngIf="orderManager.getQuantity(item) > 0 && !item?.variations">
                <!-- <ion-button fill="clear" class="btn-qty-remove AQA-minus-button"
                    (click)="removeClicked(item);$event.stopPropagation();">
                    <ion-icon name="md-remove"></ion-icon>
                </ion-button> -->
                <ion-icon (click)="removeClicked(item);$event.stopPropagation();" name="md-remove"
                    class="btn-qty-remove AQA-minus-button"></ion-icon>

                <div class="qtn-with-item">
                    <p class="AQA-item-qty">{{orderManager.getQuantity(item)}}</p>
                </div>

                <ion-icon name="md-add" class="btn-qty-add AQA-add-button"></ion-icon>
                <!-- <ion-button fill="clear" class="btn-qty-add AQA-add-button">
                    <ion-icon name="md-add"></ion-icon>
                </ion-button> -->

            </div>
        </div>
        <div class="item-info" [ngClass]="{ isEn : translateService.currentLang === 'en'}">

            <div class="item-title">
                {{itemName[i]}}
            </div>
            <p *ngIf="item?.desc && item?.desc.length > 0" class="item-desc line-clamp AQA-itemDesc">{{item.desc}}</p>

            <div class="item-price" *ngIf="!settings?.hideZeroItemPrice || item.price > 0">
                <span *ngIf="!item.minPrice" class="itemPrice-text">{{currencySign}}
                    {{item|itemPrice}}
                </span>
                <span *ngIf="item.minPrice" class="itemPrice-text">{{currencySign}}
                    {{item|itemPrice}}
                    {{"global.up" | translate}}</span>
                <!-- <span>{{orderManager?.store?.currencySign}}{{item.price | number : '1.0-2'}}</span> -->
                <!-- <ion-icon class="icon-next" name="ios-arrow-forward"></ion-icon> -->
            </div>
        </div>
    </div>
</div>